export default __webpack_public_path__ + "static/media/candidates-200px.54f3daad.svg";